import { Chip, Grid, Typography, Box } from "@mui/material";
import CircleIcon from "@mui/icons-material/Circle";
import { Bar } from "react-chartjs-2";
import { generateColorFromString } from "utils/GenerateColorFromString/GenerateColorFromString";
import { numberFormatter } from "utils/HelperFunctions";
import FunnelTierOptions from "./FunnelTierOptions";

function FunnelTier({ tier, index, totals, handleDeleteTier, handleRemoveKpi }) {
  const data = {
    labels: [""],
    datasets: totals[index]?.kpiData.map((kpi) => ({
      label: kpi.kpiActionName,
      backgroundColor: generateColorFromString(kpi.kpiActionName),
      data: [[kpi.min, kpi.max]],
      totalCount: kpi.totalCount,
    })),
  };
  const options = {
    maintainAspectRatio: false,
    responsive: true,
    indexAxis: "y",
    animation: false,
    scales: {
      x: {
        display: false,
        stacked: false,
        min: totals?.xMin || 0,
        max: totals?.xMax || 0,
      },
      y: {
        display: false,
        stacked: true,
      },
    },
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: (ctx) => `${numberFormatter(ctx.dataset.totalCount)} total KPIs`,
          title: (ctx) => ctx[0]?.dataset.label,
          labelPointStyle: () => ({
            pointStyle: "circle",
          }),
          labelTextColor: () => "#333333",
        },
        usePointStyle: true,
        position: "average",
        mode: "point",
        intersect: true,
        // yPadding: 10,
        // xPadding: 10,
        caretSize: 9,
        caretPadding: 10,
        backgroundColor: "white",
        bodyColor: "#000",
        bodyFontColor: "#000",
        borderColor: "#888",
        borderWidth: 1,
        titleColor: "black",
        footerColor: "black",
        yAlign: "bottom",
      },
    },
    interaction: {
      mode: "dataset",
    },
  };

  const getTierTotalsDisplay = () => {
    if (!tier.kpis.length) return "";

    return (
      <Box
        sx={{
          px: "1.5rem",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <Box sx={{ display: "inline-flex", alignItems: "center" }}>
          <Typography sx={{ fontSize: "1.25rem", fontWeight: "700", lineHeight: 1 }}>
            {numberFormatter(totals[index]?.count || 0)}
          </Typography>
          <Typography
            sx={{
              pl: "0.5rem",
              fontSize: "0.75rem",
              lineHeight: 1,
            }}
          >
            total KPIs
          </Typography>
        </Box>
        {index > 0 && totals[index]?.percentage > 0 && (
          <Box sx={{ display: "inline-flex", ml: "1rem" }}>
            <Typography
              sx={{ fontSize: "1.25rem", lineHeight: 1 }}
            >{`${totals[index]?.percentage}%`}</Typography>
          </Box>
        )}
      </Box>
    );
  };

  return (
    <Grid container sx={{ overflow: "hidden", height: "100%" }}>
      <Grid item sx={{ width: "calc(100% - 20px)" }}>
        <Grid container sx={{ height: "100%", maxHeight: "6rem" }}>
          <Grid item xs={4} sx={{ flexWrap: "wrap", overflowY: "auto", height: "100%" }}>
            {tier.kpis.map((kpi) => (
              <Chip
                key={kpi.id}
                icon={<CircleIcon />}
                label={kpi.name}
                title={kpi.name}
                size="small"
                onDelete={() => handleRemoveKpi(tier.id, kpi.id)}
                sx={{
                  fontSize: "0.75rem",
                  "& .MuiChip-icon": {
                    color: generateColorFromString(kpi.name),
                  },
                }}
              />
            ))}
          </Grid>
          <Grid item xs={8} sx={{ textAlign: "center" }}>
            <Grid container direction="column">
              <Grid item sx={{ height: "25px", width: "100%" }}>
                {getTierTotalsDisplay()}
              </Grid>
              {tier.kpis.length > 0 && (
                <Grid item sx={{ height: "70px", width: "100%", pl: "0.5rem" }}>
                  <Bar options={options} data={data} />
                </Grid>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid item sx={{ width: "20px" }}>
        {index > 0 && <FunnelTierOptions id={tier.id} handleDeleteTier={handleDeleteTier} />}
      </Grid>
    </Grid>
  );
}

export default FunnelTier;
